<template>
<v-dialog
  :value="showDlgUpload"
  persistent
  @close="cancel"
  max-width="500"
  :content-class="'ModalSuccesUpload'"
>
  <v-card class="ModalSuccesUpload__card d-flex flex-column px-6 py-8">
    <div class="ModalSuccesUpload__close d-flex justify-end">
      <v-btn
        small
        @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="ModalSuccesUpload__title">
      Баннер успешно загружен
    </div>

    <div class="ModalSuccesUpload__body">
      <v-img
        src="@/assets/images/adminPanel/success.webp"
        max-width="86px"
        :class="'BannerPreview__img'"
      />
    </div>
  </v-card>
</v-dialog>
</template>

<script>

/**
 * Компонент: ModalSuccesUpload
 * Описание:
 */
export default {
  name: 'ModalSuccessUpload',

  components: { },

  props: {
    showDlgUpload: {
      type: Boolean,
      default: false
    }
  },
  emits: ['closeModal', 'acceptUpload'],

  data() {
    return {};
  },

  computed: {},

  watch: {},

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    cancel() {
      this.$emit('closeModal');
    }
  },
};
</script>

<style scoped lang="scss">
.ModalSuccesUpload{

}
</style>
